module.exports = __webpack_public_path__ + "img/bni-light.845ee51f.png";